const overrideCheckbox = (theme) => {
  theme.overrides.MuiCheckbox = {
    colorSecondary: {
      color: theme.colorPalette.green_75,
      '&$disabled': {
        color: theme.colorPalette.beige_25,
        opacity: 0.6
      }
    },
    colorPrimary: {
      color: theme.colorPalette.orange_50,
      position: 'relative',
      '&::before': {
        content: '" "',
        display: 'block',
        height: 16,
        width: 16,
        float: 'left'
      },
      '& >span': {
        position: 'absolute'
      },
      '&$checked': {
        color: theme.colorPalette.orange_50
      },
      '&$checked::before': {
        backgroundColor: theme.colorPalette.white
      },
      '&$disabled': {
        color: theme.colorPalette.beige_25,
        opacity: 0.6,
        '&$checked': {
          color: theme.colorPalette.orange_50
        }
      }
    },
    root: {
      marginTop: 0
    }
  };
};

export default overrideCheckbox;
